import { getChainId, } from "wagmi/actions";
import { getContractAddress, type TokenIdentifier, getTokenDefinition, } from "@bracket/chainography";
import { wagmiConfig as config, } from "@wagmiconfig";
import { allowance, } from "@bracket/contractor-next/erc20"



/**
 * Gets the token allowance for a given contract, such as BrktETHRouter
 * @param {Object} params - The parameters object
 * @param {TokenDefinition} params.token - The token to get the allowance for
 * @returns {Promise<bigint>} The allowance of the token
 * @throws {Error} If the allowance value is invalid
 */
export const getContractAllowance = async ({
  token,
	spender,
}: {
	token: TokenIdentifier;
	spender: string;
}): Promise<bigint> => {
  const address = getContractAddress(spender, getChainId(config));
  const tokenDefinition = getTokenDefinition(token);
  return allowance({
		token: tokenDefinition,
		spender: address,
		config,
	});
}
